import { QUICK_INSERT_LEFT_OFFSET, dragHandleGap, topPositionAdjustment } from '../consts';

export type SurfacePlacement = {
	left: number;
	top: number;
	transform: string;
};

export type SurfacePlacementOptions = {
	layout: string;
	nodeRect: Pick<DOMRect, 'left' | 'top'>;
	nodeType: string;
	nodeTypeWithLevel: string;
	parentNodeType?: string;
};

export const getAbsoluteSurfacePlacement = ({
	offsetParentRect,
	offsetParentScrollLeft,
	offsetParentScrollTop,
	placement,
}: {
	offsetParentRect?: Pick<DOMRect, 'left' | 'top'>;
	offsetParentScrollLeft: number;
	offsetParentScrollTop: number;
	placement: SurfacePlacement;
}): SurfacePlacement => ({
	...placement,
	left: placement.left - (offsetParentRect?.left ?? 0) + offsetParentScrollLeft,
	top: placement.top - (offsetParentRect?.top ?? 0) + offsetParentScrollTop,
});

/**
 * Positions the Task 1 left surface beside the legacy drag-handle slot.
 * The surface's own width is handled by the transform, so later controls do not require measuring it.
 */
export const getSurfacePlacement = ({
	layout,
	nodeRect,
	nodeType,
	nodeTypeWithLevel,
	parentNodeType,
}: SurfacePlacementOptions): SurfacePlacement => ({
	left: nodeRect.left,
	top: nodeRect.top + topPositionAdjustment(nodeTypeWithLevel, layout),
	transform: `translateX(calc(-100% - ${dragHandleGap(nodeType, parentNodeType) + QUICK_INSERT_LEFT_OFFSET}px))`,
});
